/**
 * Error text for snackbars from a failed API call.
 * V2: data.error.message, then data.message (sendResErrV2).
 */
export function getApiErrorMessage(error, fallback) {
  return error?.response?.data?.error?.message
    ?? error?.response?.data?.message
    ?? error?.message
    ?? fallback;
}

export function parseCycleSchedulerResponse(body) {
  const payload = body?.data;
  if (Array.isArray(payload)) {
    return { notifications: payload, isCycleActive: true };
  }
  if (payload && typeof payload === 'object') {
    return {
      notifications: payload.notifications || [],
      isCycleActive: payload.isCycleActive !== false,
    };
  }
  return { notifications: [], isCycleActive: true };
}
